import Cookies from "universal-cookie";
import appSettings from "../const/appSettings";

const cookies = new Cookies();

class FetchService {
    get = async (url, jtw) => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
            const response = await fetch(new Request(appSettings.apiUrl + url, {
                method: "GET",
                headers: this.#getHeaders(jtw),
                signal: controller.signal
            }));
            if (!response.ok) {
                const error = new Error(`API request failed with status ${response.status}`);
                error.status = response.status;
                throw error;
            }
            return await response.json();
        } finally {
            clearTimeout(timeout);
        }
    };

    post = async (url, body, jtw) => {
        return new Promise((resolve, reject) => {
            const request = new Request(appSettings.apiUrl + url, {
                method: "POST",
                headers: this.#getHeaders(jtw),
                body: JSON.stringify(body)
            });

            return fetch(request)
                .then((response) => {
                        if (response) {
                            resolve(response.json());
                        } else {
                            resolve([]);
                        }
                    }
                ).catch(e => {
                    console.log("w", e);
                    resolve([]);
                });
        });
    };

    put = async (url, body, jtw) => {
        return new Promise((resolve, reject) => {
            const request = new Request(appSettings.apiUrl + url, {
                method: "PUT",
                headers: this.#getHeaders(jtw),
                body: JSON.stringify(body)
            });

            return fetch(request)
                .then((response) => {
                        if (response) {
                            resolve(response.json());
                        } else {
                            resolve([]);
                        }
                    }
                ).catch(e => {
                    console.log("w", e);
                    resolve([]);
                });
        });
    };

    #getHeaders = (jwt) => {
        const headers = {
            "Accept": "application/json",
            "Content-Type": "application/json"
        };

        if (jwt) {
            headers["AUTHORIZATION"] = `Bearer ${ jwt }`;
        }

        if (!jwt) {
            const kk = cookies.get("tpir");
            if (kk) {
                headers["AUTHORIZATION"] = `Bearer ${ kk }`;
            }
        }
        // headers['AUTHORIZATION'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3OTUwMDg3MTIsInVzZXJJZCI6IjExOTcyODY0NjkifQ.r3rkdEUHOvtaTKYXJSqHpU5lqgXkNPZpgvrndCyXUrE`;
        return headers;
    };
}

const fetchService = new FetchService();
export default fetchService;
